module.exports = __webpack_public_path__ + "img/food-13.ee81e322.jpg";